import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { ProcessingStatus } from '../../types/authenticateSmartcheckSessionDto'

interface DocumentUploadConfig {
	uploadFiles: (files: File[]) => Promise<
		{
			fileId: string
			fileName: string
			url: string
		}[]
	>
	updateCaseProcessingStatus: (
		caseId: string,
		processingStatus: ProcessingStatus,
	) => Promise<void>
}

export interface DocumentUploadData {
	caseId: string
	clientName: string
	documentTypes: string[]
}

export type DocumentUploadModuleData = ModuleData<
	DocumentUploadData,
	void,
	DocumentUploadConfig
>

export const DocumentUploadModuleProvider: typeof ModuleProvider<DocumentUploadModuleData> =
	ModuleProvider

export const useDocumentUploadModule: typeof useModule<DocumentUploadModuleData> =
	useModule
